/**
 * Created by shubham on 27/6/17.
 */

import { NgModule } from '@angular/core';

//file upload
import { FileSelectDirective } from 'ng2-file-upload';
import { TranslateModule } from 'ng2-translate';

@NgModule({
    declarations: [
        FileSelectDirective
    ],
    imports: [
        TranslateModule
    ],
    exports: [
        FileSelectDirective
    ]
})
export class FileUploadModule {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/fileUpload.module.ts